const DonutChart = require('okCharts/DonutChart');

module.exports = DonutChart;
